import { render, staticRenderFns } from "./ShippingCostTable.vue?vue&type=template&id=ae1572fa&scoped=true"
import script from "./ShippingCostTable.vue?vue&type=script&lang=js"
export * from "./ShippingCostTable.vue?vue&type=script&lang=js"
import style0 from "./ShippingCostTable.vue?vue&type=style&index=0&id=ae1572fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1572fa",
  null
  
)

export default component.exports